var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedIn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.575195 18C0.575195 27.9411 8.63407 36 18.5752 36C28.5163 36 36.5752 27.9411 36.5752 18C36.5752 8.05888 28.5163 0 18.5752 0C8.63407 0 0.575195 8.05888 0.575195 18Z",
    fill: "#0073B1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7502 25.875H10.9252V13.8375H14.7502V25.875ZM12.8377 12.15C11.6002 12.15 10.7002 11.25 10.7002 10.0125C10.7002 8.775 11.7127 7.875 12.8377 7.875C14.0752 7.875 14.9752 8.775 14.9752 10.0125C14.9752 11.25 14.0752 12.15 12.8377 12.15ZM28.7002 25.875H24.8752V19.35C24.8752 17.4375 24.0877 16.875 22.9627 16.875C21.8377 16.875 20.7127 17.775 20.7127 19.4625V25.875H16.8877V13.8375H20.4877V15.525C20.8252 14.7375 22.1752 13.5 24.0877 13.5C26.2252 13.5 28.4752 14.7375 28.4752 18.45V25.875H28.7002Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.8fd59318f4e2f051340659628d77e01e.svg";
export { ForwardRef as ReactComponent };